<template>
  <div class="row page-header-banner-page-title">
    <div class="col">
      <h4 class="q-mt-none q-mb-none"><slot name="title"></slot></h4>
      <div class="q-mt-none q-mb-none"><slot name="title-toggle"></slot></div>
    </div>
    <div class="col-3 page-header-banner-button-area">
      <slot name="button-area"></slot>
    </div>
  </div>
</template>

<style scoped>
.page-header-banner-page-title {
  padding: 22px 10% 18px;
}
.page-header-banner-page-title h4 {
  color: var(--q-primary);
  font-size: 1.6rem;
  line-height: 1.6rem;
  letter-spacing: 3px;
}
.page-header-banner-button-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
